module.exports = __webpack_public_path__ + "img/water_tower.ff79ea3d.svg";